export default __webpack_public_path__ + "static/gmailIcon-40408fe7329c917af18a3c43ed3c21bf.svg";